export default "__VITE_ASSET__$d9tsZ9d__"